import {UIGameManager} from '../UIGameManager'
import {UIGamePlayerInformationView} from './UIGamePlayerInformationView'
import {UIGameProgressCardsToolTipView} from '../ui_game_tooltip/UIGameProgressCardsToolTipView'
import {UIGamePlayerInformationProgressCardVictoryPointView} from './UIGamePlayerInformationProgressCardVictoryPointView'
import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {TranslationObject} from '@colonist/i18n'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {Sprites} from '../UIGameImageDictionary'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'

export abstract class UIGamePlayerInformationProgressCardController implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    private playerInformationForToolTipView: UIGamePlayerInformationView | undefined
    private playerInformationProgressCardToolTipView: UIGameProgressCardsToolTipView | undefined
    private playerInformationProgressCardVictoryPointViews: UIGamePlayerInformationProgressCardVictoryPointView[]

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        if(this.uiGameManager.playersController == undefined) return
        this.updateAllPlayerInformationViewsToShowProgressCardIcon()
        this.playerInformationProgressCardVictoryPointViews = []
        this.initPlayerInformationProgressCardVictoryPointViews()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.CanvasResized:
                this.updateAllPlayerInformationViewsToShowProgressCardIcon()
                this.initPlayerInformationProgressCardVictoryPointViews()
                break
            default: break
        }
    }

    private updateAllPlayerInformationViewsToShowProgressCardIcon() {
        if(this.uiGameManager.playersController == undefined) return
        const newTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.card_progress_back)
        for(const player of this.uiGameManager.gameState.players) {
            const playerInformation = this.uiGameManager.playersController.getPlayerInformationViewWithColor(player.color)
            if(playerInformation == undefined) continue

            playerInformation.developmentCardView.view.texture = newTexture
            playerInformation.developmentCardView.view.removeAllListeners()
            this.setProgressCardToolTip(playerInformation)
        }
    }

    protected setProgressCardToolTip(playerInformation: UIGamePlayerInformationView) {
        if(UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return
        this.uiGameManager.toolTipController.createTipFromTooltipView(() => this.getPlayerInformationProgressCardToolTip(playerInformation), playerInformation.developmentCardView.view)
    }

    // eslint-disable-next-line class-methods-use-this
    protected getPlayerInformationProgressCardToolTip(playerInformation: UIGamePlayerInformationView) {
        const hideCardCount = false
        const cardView = playerInformation.developmentCardView
        const progressCards = playerInformation.progressCardsPlayerValidator?.progressCards.cards ?? []
        const title: TranslationObject = {key: 'strings:game.playerInformation.progressCard'}
        return new UIGameProgressCardsToolTipView(cardView, title, progressCards, hideCardCount, playerInformation)
    }

    protected removePlayerInformationProgressCardToolTip() {
        if(this.playerInformationProgressCardToolTipView == undefined) return
        this.playerInformationProgressCardToolTipView.removeToolTip()
        this.playerInformationProgressCardToolTipView = undefined
        this.playerInformationForToolTipView = undefined
    }

    private initPlayerInformationProgressCardVictoryPointViews() {
        if(this.uiGameManager.playersController == undefined) return
        this.playerInformationProgressCardVictoryPointViews.forEach((view) => view.destroy())
        this.playerInformationProgressCardVictoryPointViews = []

        for(const playerInformation of this.uiGameManager.playersController.playerInformationViews) {
            const newPlayerInformationProgressCardVictoryPointView = this.createProgressCardVictoryPointView(playerInformation)
            this.playerInformationProgressCardVictoryPointViews.push(newPlayerInformationProgressCardVictoryPointView)
        }
    }

    protected abstract createProgressCardVictoryPointView(playerInformation: UIGamePlayerInformationView): UIGamePlayerInformationProgressCardVictoryPointView
}
